export enum ModalType {
  LOGIN,
  LOGOUT,
  PURCHASE,
  GIFT,
  SUBSCRIBER_MELODY_SETTINGS,
  SUBSCRIBER_MELODY_DELETE,
  ACTIVATE_SUBSCRIPTION,
  DEACTIVATE_SUBSCRIPTION,
  SUBSCRIPTION_INFO,
  CONTACT_INFO,
  EDIT_CONTACT,
  DELETE_CONTACT,
  GROUP_INFO,
  EDIT_GROUP,
  DELETE_GROUP,
  UGC_UPLOADED,
  CHOOSE_SUBSCRIPTIONS
}
